import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, TokenService } from '@anduin/auth';
import { ignoreFalsy } from '@anduin/shared';
import { Observable, Subject } from 'rxjs';
import { switchMap, take, takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../base-component.abstract';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent extends BaseComponent implements OnInit, OnDestroy {
  private _unsubscribe$ = new Subject<void>();

  // show loading state until staff record has been created and persisted to Firebase
  showLoadingState$: Observable<boolean>;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly tokenService: TokenService,
  ) {
    super();
    this.showLoadingState$ = authService.navigateOnStaffRecordCreation();
  }

  ngOnInit(): void {
    // user manually types in '/login' to URL
    if (this.authService.isAuthenticated()) {
      this.router.navigateByUrl('home');
      return;
    }

    // session timed out, so auth guard navigates to login
    if (this.authService.staffRecordBeingCreated$.value === false) {
      this.authService
        .logInSSOUser()
        .pipe(
          take(1),
          ignoreFalsy(),
          switchMap((_) => this.router.navigateByUrl('home')),
          takeUntil(this._unsubscribe$),
        )
        .subscribe();
    }
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }
}
